import { Trans, useTranslation } from "react-i18next";

import { TableHeaderProps } from "src/components/TableHeader";

export function useTableHeaders(headers: { key: string; [rest: string]: string | any }[], translation: string) {
  const { t } = useTranslation(translation);
  const result = {} as TableHeaderProps["headers"];

  headers.forEach((item) => {
    result[item.key] = {
      ...item,
      title: t(item.title),
      sort: item.sort,
      tooltip: !!item.tooltip ? (
        typeof item.tooltip === "string" ? (
          t(item.tooltip)
        ) : typeof item.tooltip === "function" ? (
          item.tooltip(t)
        ) : (
          <Trans>{t(item.tooltip)}</Trans>
        )
      ) : null
    };
  });
  return result;
}
